import React, { Component } from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";
import {bindActionCreators} from "redux";

import Side from "../../../components/scholar/admin/detail/side";

import * as Actions from "../../../store/modules/scholars";
import SContent from "../../../components/scholar/admin/detail/Scontent";

class Scholar extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className="container-fluid mt-3 detail-wrap">
        <div className="row">
          <SContent />
          {this.props.showSide !== 'false' &&
          <div className="sidebar-list">
            <Side/>
          </div>
          }
        </div>
      </div>
    )
  }
}
  

export default connect(
  (state) => ({
    showSide : state.scholars.showSide  ? state.scholars.showSide  : 'true'
  }),
  (dispatch) => ({
    dataActions: bindActionCreators(Actions, dispatch)
  }),
)(Scholar)

Scholar.propTypes = {
  activeTab: PropTypes.number
};